
const contents = "mutation UpdateUserPreferencesClients($isModernClientPreferred: Boolean!) {\n  updateUserPreferences(input: {isModernClientPreferred: $isModernClientPreferred}) {\n    userPreferences {\n      webClientPreference\n    }\n  }\n}\n";
const sha256Hash = "94bde5f79ad4fbfa1d1e49ee91584d44985476f83ded5f97a679c2608088ef6d";
export default { contents: contents, sha256Hash: sha256Hash };
